"use client";
import {
  PopoverContextProvider
} from "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import {
  usePopoverStore
} from "../__chunks/CBC47ZYL.js";
import "../__chunks/QYS5FHDY.js";
import "../__chunks/KGK2TTFO.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/popover/popover-provider.tsx
import { jsx } from "react/jsx-runtime";
function PopoverProvider(props = {}) {
  const store = usePopoverStore(props);
  return /* @__PURE__ */ jsx(PopoverContextProvider, { value: store, children: props.children });
}
export {
  PopoverProvider
};
